Share = {
    vk(purl, ptitle, pimg, text) {
        url  = '//vk.com/share.php?';
        url += 'url='          + encodeURIComponent(purl);
        url += '&title='       + encodeURIComponent(ptitle);
        url += '&description=' + encodeURIComponent(text);
        url += '&image='       + encodeURIComponent(pimg);
        url += '&noparse=true';
        Share.popup(url);
    },
    ok(purl, text) {
        share_url = `https://connect.ok.ru/offer?url=${encodeURIComponent(purl)}&title=${encodeURIComponent(text)}`;
        Share.popup(share_url);
    },
    fb(purl, ptitle, pimg, text) {
        let share_url;
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent)) {
            share_url = `http://m.facebook.com/sharer.php?u=${purl}`;
        }
        else {
            share_url = 'http://www.facebook.com/sharer.php?s=100'
                + '&p[title]=' + encodeURIComponent(ptitle)
                + '&p[url]='       + encodeURIComponent(purl)
                + '&p[images][0]=' + encodeURIComponent(pimg);
        }

        Share.popup(share_url);
    },
    tw(purl, ptitle) {
        url  = '//twitter.com/share?';
        url += 'text='      + encodeURIComponent(ptitle);
        url += '&url='      + encodeURIComponent(purl);
        url += '&counturl=' + encodeURIComponent(purl);
        Share.popup(url);
    },
    mail(purl, ptitle, pimg, text) {
        url  = '//connect.mail.ru/share?';
        url += 'url='          + encodeURIComponent(purl);
        url += '&title='       + encodeURIComponent(ptitle);
        url += '&description=' + encodeURIComponent(text);
        url += '&imageurl='    + encodeURIComponent(pimg);
        Share.popup(url);
    },
    popup(url) {
        window.open(url,'','toolbar=0,status=0,width=626,height=436');
    }
};